export default __webpack_public_path__ + "static/media/flag-orkney-islands.712b0253.svg";